import PropTypes from 'prop-types';
import { Component } from 'react';

export class Delay extends Component {
  static propTypes = {
    time: PropTypes.number,
    children: PropTypes.node,
  };

  static defaultProps = {
    time: 0,
  };

  state = {
    show: !this.props.time,
  };

  componentDidMount() {
    this.timeout = setTimeout(
      () => this.setState({ show: true }),
      this.props.time,
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    return this.state.show ? this.props.children : null;
  }
}
